// extracted by mini-css-extract-plugin
export default {"skeleton":"SkeletonBrandCard_skeleton__INdxY","skeleton-loading":"SkeletonBrandCard_skeleton-loading__BF0Nf"};